export enum SwapQualityIssueListType {
    PendingResponse = 1,
    IssueReportedIncomplete = 2,
    IssueReportedComplete = 3,
    NoIssueReported = 4,
    All = 5
}